import { render, staticRenderFns } from "./EventsPerDay.vue?vue&type=template&id=023f02c8&scoped=true"
import script from "./EventsPerDay.vue?vue&type=script&lang=js"
export * from "./EventsPerDay.vue?vue&type=script&lang=js"
import style0 from "./EventsPerDay.vue?vue&type=style&index=0&id=023f02c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f02c8",
  null
  
)

export default component.exports